import axios from "axios";
export const getMachinesLedesma = async () => {
  try {
    const res = await axios.get(
      "https://caldenflow.cn-grupo.net:15443/api/getVehiculosLedesma"
    );
    return res.data;
  } catch (error) {
    console.error("Error al obtener los camiones:", error);
    return null;
  }
};
export const getSupervisorsLedesma = async () => {
  try {
    const res = await axios.get(
      "https://caldenflow.cn-grupo.net:15443/api/getPersonalLedesma"
    );
    return res.data;
  } catch (error) {
    console.error("Error al obtener los camiones:", error);
    return null;
  }
};
export const getBlocksLedesma = async () => {
  try {
    const res = await axios.get(
      "https://caldenflow.cn-grupo.net:15443/api/getBloquesLedesma"
    );
    return res.data;
  } catch (error) {
    console.error("Error al obtener los camiones:", error);
    return null;
  }
};
export const getMachines = async () => {
  try {
    const res = await axios.get(
      "https://caldenflow.cn-grupo.net:15443/api/getVehiculos"
    );
    return res.data;
  } catch (error) {
    console.error("Error al obtener los camiones:", error);
    return null;
  }
};

export const getSupervisors = async () => {
  try {
    const res = await axios.get(
      "https://caldenflow.cn-grupo.net:15443/api/getPersonal"
    );
    return res.data;
  } catch (error) {
    console.error("Error al obtener los camiones:", error);
    return null;
  }
};

export const getBlocks = async () => {
  try {
    const res = await axios.get(
      "https://caldenflow.cn-grupo.net:15443/api/getBloques"
    );
    return res.data;
  } catch (error) {
    console.error("Error al obtener los camiones:", error);
    return null;
  }
};

export const getDrivers = async () => {
  try {
    const res = await axios.get(
      "https://caldenflow.cn-grupo.net:15443/api/getChoferesCamionCisterna"
    );
    return res.data;
  } catch (error) {
    console.error("Error al obtener los camiones:", error);
    return null;
  }
};

export const getTrucks = async () => {
  try {
    const res = await axios.get(
      "https://caldenflow.cn-grupo.net:15443/api/getCamiones"
    );
    return res.data;
  } catch (error) {
    console.error("Error al obtener los camiones:", error);
    return null;
  }
};

export const getProduct = async () => {
  try {
    const res = await axios.get(
      "https://caldenflow.cn-grupo.net:15443/api/getProductos"
    );
    return res.data;
  } catch (error) {
    console.error("Error al obtener los camiones:", error);
    return null;
  }
};

export const getOrdenes = async () => {
  try {
    const res = await axios.get(
      "https://caldenflow.cn-grupo.net:15443/api/getOrdenes",
      { timeout: 20000 }
    );
    return res.data;
  } catch (error) {
    if (error.code === "ECONNABORTED") {
      alert("La petición ha excedido el tiempo de espera.");
    } else {
      console.error("Error: getOrdenes", error.message);
    }
    return [];
  }
};

export const getNV = async () => {
  try {
    const res = await axios.get(
      "https://caldenflow.cn-grupo.net:15443/api/getNV",
      { timeout: 20000 }
    );
    return res.data;
  } catch (error) {
    if (error.code === "ECONNABORTED") {
      alert("La petición ha excedido el tiempo de espera.");
    } else {
      console.error("Error: getOrdenes", error.message);
    }
    return [];
  }
};

export const updatePatente = async (data) => {
  try {
    const res = await axios.post(
      "https://caldenflow.cn-grupo.net:15443/api/asignaPatente",
      data,
      { timeout: 20000 }
    );
    return res.data;
  } catch (error) {
    if (error.code === "ECONNABORTED") {
      alert("La petición ha excedido el tiempo de espera.");
    } else {
      console.error("Error: updatePatente", error.message);
      throw error;
    }
    return null;
  }
};
